import { useContext, useEffect, useState } from 'react';
import { PaymentMethodEnum } from '@/types/common';
import { CheckoutContext } from '@/context/CheckoutContext';
import { isInlineScreenSurface } from '@/utils/screenSurface';

/**
 * A sub-screen opened in place (the viewer) sits in the payment column with the
 * method tiles still live above it, so picking another method has to dismiss it
 * — otherwise the old screen outlives the selection that opened it and the tap
 * reads as a no-op (`PaymentMethodForm` stays hidden while a viewer screen is
 * set, see `useTemplateFeatures`).
 *
 * Gated on the surface, not the device: EMBEDDED_VIEW is phone-only yet renders
 * its screens in place, while DEFAULT on a phone uses the drawer, whose backdrop
 * already blocks the tiles and which owns its own dismissal.
 */
export const useApplicationState = () => {
  const context = useContext(CheckoutContext);
  const [lastPaymentMethodSelected, setLastPaymentMethodSelected] = useState<PaymentMethodEnum | undefined>(undefined);

  useEffect(() => {
    if (!context || !isInlineScreenSurface(context.template?.type)) return;

    if (lastPaymentMethodSelected !== undefined && lastPaymentMethodSelected !== context.paymentMethodSelected) {
      context.viewer.setViewer(undefined);
    }
    setLastPaymentMethodSelected(context.paymentMethodSelected);
  }, [context?.paymentMethodSelected, lastPaymentMethodSelected, context]);
};
